import { useState } from 'react';
import { CardContainer } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { useRect } from 'react-use-rect';
import type { Job } from '../../../types';
import { usePopup } from '../../popup/PopupProvider';
import { HorizontalItem } from './HorizontalItem';
import { VerticalItem } from './VerticalItem';

export const Item = ({ data }: { data: Job }) => {
  const { handleShowPopup } = usePopup();
  const { jobBackgroundColor, jobBorderRadius } = useSettings();
  const [width, setWidth] = useState(0);
  const [ref] = useRect(({ width }) => setWidth(width), {
    resize: true
  });

  return (
    <CardContainer
      className="Item__Card-sc"
      backgroundColor={jobBackgroundColor}
      ref={ref}
      onClick={() => handleShowPopup(data.id)?.()}
      style={{
        cursor: `${handleShowPopup(data.id) ? 'pointer' : 'default'}`,
        borderRadius: `${jobBorderRadius ?? 8}px`
      }}
    >
      {width < 800 ? (
        <VerticalItem data={data} cardWidth={width} />
      ) : (
        <HorizontalItem data={data} cardWidth={width} />
      )}
    </CardContainer>
  );
};
